export default "__VITE_ASSET__hK2i$2SR__"